<script setup lang="ts">

import { useAuthStore } from '@shared/api'
import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'
import { BtnCheckbox, BtnPrimary } from '@shared/ui/buttons'

import LinkAuth from './LinkAuth.vue'
import { useSectionLogin } from '../model/use-section-login.hook'

defineOptions({
  name: 'SectionLogin',
})

const authStore = useAuthStore()

const {
  forgotUrl,
  onInputEmail,
  onInputPassword,
  onClickRemember,
  setSubmitLogin,
} = useSectionLogin()

</script>

<template>
  <div class="section-login">
    <div class="section-login__field">
      <InputPrimary
        label="Email"
        type="email"
        name="email"
        :value="authStore.getEmail || ''"
        @update:value="onInputEmail"
      />
      <AppText
        v-if="authStore.getErrorEmail"
        name="body2"
        color="red-500"
        class="section-login__error"
      >
        {{ authStore.getErrorEmail }}
      </AppText>
    </div>
    <div class="section-login__field">
      <InputPrimary
        label="Password"
        type="password"
        name="password"
        :value="authStore.getPassword || ''"
        @update:value="onInputPassword"
      />
      <AppText
        v-if="authStore.getErrorPassword"
        name="body2"
        color="red-500"
        class="section-login__error"
      >
        {{ authStore.getErrorPassword }}
      </AppText>
    </div>
    <BtnCheckbox
      text="Remember me"
      :checked="authStore.isRemember"
      @click="onClickRemember"
    />
    <div class="section-login__control">
      <LinkAuth
        text="Forgot your password?"
        :href="forgotUrl"
      />
      <BtnPrimary
        text="Log in"
        :disabled="authStore.isLoading"
        @click="setSubmitLogin"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./SectionLogin.scss" />
